import { useLayoutEffect, useState } from "react";

// The ACCB header sits in normal flow (its AppBar is position="static") and is
// sized by its logo, so the height left over for a dashboard cannot be
// hardcoded. Measure where the element actually starts and claim exactly the
// rest of the viewport, so the page itself never scrolls and only the panes
// inside it do (the header stays put).
export default function useViewportFill(ref) {
  const [height, setHeight] = useState("100vh");

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return undefined;

    const measure = () => {
      // pageYOffset keeps this correct even if the page is scrolled when we
      // first measure; it is the distance from the top of the document.
      const top = el.getBoundingClientRect().top + window.pageYOffset;
      setHeight(`calc(100vh - ${Math.max(0, Math.round(top))}px)`);
    };

    measure();
    window.addEventListener("resize", measure);

    // Watch the header rather than our own parent: its height is what we are
    // subtracting, and observing an ancestor we resize would feed back on
    // itself.
    let observer;
    const header = el.previousElementSibling;
    if (header && typeof ResizeObserver !== "undefined") {
      observer = new ResizeObserver(measure);
      observer.observe(header);
    }

    return () => {
      window.removeEventListener("resize", measure);
      if (observer) observer.disconnect();
    };
  }, [ref]);

  return height;
}
